/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type LogoutSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type LogoutRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type LogoutResponse = {
  headers: { [k: string]: Array<string> };
};

/** @internal */
export type LogoutSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const LogoutSecurity$outboundSchema: z.ZodMiniType<
  LogoutSecurity$Outbound,
  LogoutSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function logoutSecurityToJSON(logoutSecurity: LogoutSecurity): string {
  return JSON.stringify(LogoutSecurity$outboundSchema.parse(logoutSecurity));
}

/** @internal */
export type LogoutRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const LogoutRequest$outboundSchema: z.ZodMiniType<
  LogoutRequest$Outbound,
  LogoutRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function logoutRequestToJSON(logoutRequest: LogoutRequest): string {
  return JSON.stringify(LogoutRequest$outboundSchema.parse(logoutRequest));
}

/** @internal */
export const LogoutResponse$inboundSchema: z.ZodMiniType<
  LogoutResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
    });
  }),
);

export function logoutResponseFromJSON(
  jsonString: string,
): SafeParseResult<LogoutResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LogoutResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LogoutResponse' from JSON`,
  );
}
